import { ProformaDetalle } from "./proforma-detalle";
import { Bodega } from "./bodega";
import { Proveedor } from "./proveedor";

export class OrdenCompra {
    public constructor(
        public id: String = "",
        public secuencial: number = 0,
        public fecha_emision: any = "",
        public fecha_caducidad: any = "",
        //
        public subtotal_iva12:number = 0,
        public subtotal_iva0:number = 0,
        public desct_valor:number = 0,
        public desct_porcent:number = 0,
        public subtotal: number = 0,
        //
        public iva:number = 0,
        public total: number = 0,
        public observacion: String = "",
        public empresa_id: String = "",
        public sucursal_id: String = "",
        //
        public proveedor_id: String = "",
        public bodega_id: String = "1",
        public usuario_id:String = null,
        public detalle: Array<ProformaDetalle> = [],
        public proveedor: Proveedor = new Proveedor(),                    
        public bodega: Bodega = new Bodega(),
    ){}


}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/models/orden-compra.ts